import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-finops',
  imports: [CommonModule, RouterLink],
  templateUrl: './finops.html',
  styleUrl: './finops.css'
})
export class Finops {
  features = [
    {
      title: 'Cost Visibility & Reporting',
      description: 'Comprehensive dashboards and reports showing cloud spend by service, team, project, and environment.',
      icon: 'visibility'
    },
    {
      title: 'Resource Rightsizing',
      description: 'Identify and eliminate oversized instances, underutilized resources, and zombie resources.',
      icon: 'rightsizing'
    },
    {
      title: 'Reserved Instance Optimization',
      description: 'Maximize savings with RI and Savings Plans recommendations based on your usage patterns.',
      icon: 'reserved'
    },
    {
      title: 'Auto-Scaling Optimization',
      description: 'Configure intelligent auto-scaling policies to match capacity with actual demand.',
      icon: 'autoscaling'
    },
    {
      title: 'Storage Optimization',
      description: 'Lifecycle policies, storage class optimization, and snapshot management to reduce storage costs.',
      icon: 'storage'
    },
    {
      title: 'Budget Alerts & Governance',
      description: 'Automated budgets, anomaly detection, and policy enforcement to prevent cost overruns.',
      icon: 'governance'
    }
  ];

  process = [
    { step: 1, title: 'Cost Analysis', description: 'Deep dive into current cloud spending patterns and identify optimization opportunities.' },
    { step: 2, title: 'Quick Wins Implementation', description: 'Execute immediate cost-saving actions like rightsizing and cleanup.' },
    { step: 3, title: 'Strategic Optimization', description: 'Implement long-term optimizations like RIs, auto-scaling, and architecture changes.' },
    { step: 4, title: 'Ongoing Management', description: 'Continuous monitoring and optimization with monthly reviews and recommendations.' }
  ];

  caseStudy = {
    client: 'E-Commerce Global',
    industry: 'Retail & E-commerce',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=500&fit=crop',
    challenge: 'E-Commerce Global was spending $500K per month on AWS with poor visibility into costs. Resources were severely over-provisioned, and they had no optimization strategy. The CFO demanded immediate action.',
    solution: 'We implemented comprehensive FinOps including cost visibility dashboards, automated rightsizing, reserved instance optimization, and storage lifecycle policies. Established governance with budgets and alerts.',
    results: [
      { metric: '58%', description: 'Reduction in Total Cloud Costs' },
      { metric: '$290K', description: 'Monthly Savings Achieved' },
      { metric: '85%', description: 'Improvement in Resource Efficiency' },
      { metric: '< 6mo', description: 'Return on Investment Period' }
    ]
  };

  testimonial = {
    quote: 'The cloud cost optimization HoneyKode delivered was transformational. We cut our AWS bill nearly in half without sacrificing performance. The visibility and governance they built ensures costs stay under control. The ROI was incredible - we paid for the entire engagement in the first two months of savings.',
    author: 'Michael Chen',
    role: 'Director of Infrastructure',
    company: 'E-Commerce Global',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
  };

  tools = [
    { name: 'AWS Cost Explorer', category: 'AWS Native' },
    { name: 'CloudHealth', category: 'Multi-Cloud FinOps' },
    { name: 'Cloudability', category: 'Multi-Cloud FinOps' },
    { name: 'Kubecost', category: 'Kubernetes Cost' },
    { name: 'Spot.io', category: 'Compute Optimization' },
    { name: 'CloudZero', category: 'Cost Intelligence' },
    { name: 'Finout', category: 'FinOps Platform' },
    { name: 'Azure Cost Management', category: 'Azure Native' }
  ];
}
